import React from "react";
// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Button from "components/CustomButtons/Button.jsx";
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import withStyles from "@material-ui/core/styles/withStyles";
import headerLinksStyle from "assets/jss/material-dashboard-react/components/headerLinksStyle.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import TextField from "@material-ui/core/TextField";
// material-ui icons
import Snackbar from "components/Snackbar/Snackbar.jsx";
import ModalPregunta from "components/Generales/ModalPregunta";
import ModalCargando from "../../../../components/Generales/ModalCargando.js";
import ModalEditarAlumno from "../../Alumnos/ModalEditarAlumno.jsx";
import ModalProgramarCita from "../../Asesorias/ModalProgramarCita.jsx"
import Globales from "utils/Globales";
import { Edit, GroupAdd, Description, Close, AddCircle, Search, Check, Update } from "@material-ui/icons";
import CardBody from "components/Card/CardBody.jsx";
import InputAdornment from '@material-ui/core/InputAdornment';
import ModalCalificarTOEFL from "./ModalCalificarTOEFL.jsx";

class BuscarExpedientes extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            _id: '',
            EstadoAlumno: "Activo",
            ClaseAlumno: "Vacio",
            EstadoExamen: "Pendiente",
            FiltrarNombres: "",
            ListaAlumnos: [],
            AlumnoSeleccionado: {},
            Disabled: false,
            mensaje: "",
            br: false,
            show: false,
            cargando: false,
            CheckAll: false,
            colorNotificacion: 'success',
            colorTableRow: "white",
            errorIDIdioma: false,
            entroFiltrar: false,
            notificacion: false,
            CuerpoCargando: "Cargando",
            Total: 0,
            TotalSeleccionado: 0,
        };
        //Variable global para indicar el total de registros que se obtendra de la base de datos
        global.entrar = true;
        //this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
    }

    //Función para pasar datos de los alumnos desde el modal hacia la vista
    RegresarMensaje = (mensaje) => {
        this.setState({ mensaje: mensaje, colorNotificacion: "success" });
        this.showNotification();
        this.BuscarExpedientesParaCalificar();
    }
    async BuscarExpedientesParaCalificar() {
        this.setState({ ListaAlumnos: [], cargandoAlumnos: true });
        if (this.state.FiltrarNombres.length < 3) {
            this.setState({  cargandoAlumnos: false });
            return
        }
        await fetch(Globales.Url + 'Toefl/Toefl/BuscarExpedientesParaCalificar', {
            method: 'POST',
            headers: {
                Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token
            }
            , body: JSON.stringify({
                NombreAlumno: this.state.FiltrarNombres,
                EstadoAlumno: this.state.EstadoAlumno,
                EstadoExamen: this.state.EstadoExamen
            })
        }
        ).then(res => res.json())
            .then(data => {
                //console.log(data);
                if (data.error) { //Error en la respuesta
                    this.setState({ ListaAlumnos: [], mensaje: data.mensaje, colorNotificacion: "danger", Activo: 1, cargandoAlumnos: false });
                    this.showNotification();
                } else { //Filtrado exitoso
                    let ListaAux = [].concat(data.data || []);
                    this.setState({ ListaAlumnos: ListaAux, Activo: 1, cargandoAlumnos: false });
                }
            })
            .catch(err => this.setState({ mensaje: "Ocurrió un error inesperado, por favor inténtelo de nuevo", colorNotificacion: "danger", br: true, CuerpoCargando: "Error", cargando: true }));
    }

    //Funciones para abrir modales
    openModalCalificar = (Expediente) => {
        this.setState({
            idExpediente: Expediente._id,
            NombreAlumno: Expediente.NombreAlumno,
            showCalificar: true,
        });
    }
    //Funciónes que recuperan valores para los modales
    eventoModalCalificar = (valor) => {
        this.setState({ showCalificar: false },
            () => this.BuscarExpedientesParaCalificar()
        );

        if (valor != "esc") {
            this.setState({ mensaje: valor, colorNotificacion: "success" });
            this.showNotification();
        }
    }

    //Función que habilita la notificación
    showNotification() {
        var x = [];
        this.setState({ br: true });
        this.setState(x);
        this.alertTimeout = setTimeout(
            function () {
                this.setState({ br: false, notificacion: false });
                this.setState(x);
            }.bind(this),
            4000
        );
    }

    //Función para obtener el texto de los inputs
    handleChange(e) {
        const { name, value } = e.target;

        this.setState({ [name]: value },
            () => this.BuscarExpedientesParaCalificar()
        );

    }

    render() {
        const { classes } = this.props;

        let agregar;
        if (this.state.showCalificar == true) {
            agregar = (
                <ModalCalificarTOEFL
                    show={this.state.showCalificar}
                    idExpediente={this.state.idExpediente}
                    NombreAlumno={this.state.NombreAlumno}
                    eventClick={this.eventoModalCalificar}
                />
            )
        }


        if (this.state.cargando == true) {
            agregar = (
                <ModalCargando
                    Cuerpo={this.state.CuerpoCargando}
                    show={this.state.cargando}
                />
            );
        }

        let alumnos;
        if (this.state.ListaAlumnos.length > 0) {
            alumnos =
                this.state.ListaAlumnos.map(alumno => {
                    return (
                        <tr onClick={() => this.openModalCalificar(alumno)} style={{ cursor: "default" }} hover>
                            <td style={{ verticalAlign: "middle" }}>{alumno.NombreAlumno}</td>
                            <td style={{ verticalAlign: "middle" }}>{alumno.Estado.replace(/_/g, " ")}</td>
                            <td style={{ display: "flex", verticalAlign: "middle", float: "right", gap: "5px" }}>
                                <Button title="Calificar examen" color="info" round justIcon size="sm" onClick={() => this.openModalCalificar(alumno)}><Edit /></Button>
                            </td>
                        </tr>
                    )
                })
        }
        else {
            alumnos =
                <tr>
                    <td style={{ textAlign: "center", marginTop: "10px" }} colSpan={5}>NO HAY ALUMNOS</td>
                </tr>
        }


        //console.log(this.state.ListaAlumnos)
        return (
            <div>
                <GridContainer justify="center">
                    <GridItem xs={12} sm={12} md={10}>
                        <Card>
                            <CardHeader color="info" text>
                                <h4 className={classes.cardTitle}>Buscar Alumnos</h4>
                            </CardHeader>
                            <CardBody>
                                <GridContainer>
                                    <GridItem xs={12} sm={12} md={6}>
                                        <TextField
                                            fullWidth
                                            id="FiltrarNombres"
                                            variant="outlined"
                                            type="text"
                                            size="small"
                                            label="Matricula o nombre"
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <Search />
                                                    </InputAdornment>
                                                ),
                                                onChange: this.handleChange.bind(this),
                                                value: this.state.FiltrarNombres,
                                                name: "FiltrarNombres",
                                                id: "FiltrarNombres",
                                            }}
                                        />
                                    </GridItem>
                                    <GridItem style={{ marginBottom: "10px" }} xs={12} sm={12} md={3}>
                                        <FormControl fullWidth size="small" variant="outlined">
                                            <InputLabel id="estadolabel">Estado del alumno</InputLabel>
                                            <Select
                                                labelId="estadolabel"
                                                value={this.state.EstadoAlumno}
                                                onChange={this.handleChange.bind(this)}
                                                name="EstadoAlumno"
                                                label="Estado alumno"
                                            >
                                                <MenuItem disabled>Seleccione un estado</MenuItem>
                                                <MenuItem value={"Activo"}>Activo</MenuItem>
                                                <MenuItem value={"Inactivo"}>Inactivo</MenuItem>
                                                <MenuItem value={"Aplicacion_TOEFL"}>Aplicación  TOEFL</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={3}>
                                        <FormControl fullWidth size="small" variant="outlined">
                                            <InputLabel id="Claselabel">Estado del examen</InputLabel>
                                            <Select
                                                labelId="Claselabel"
                                                fullWidth={true}
                                                value={this.state.EstadoExamen}
                                                onChange={this.handleChange.bind(this)}
                                                name="EstadoExamen"
                                                label="Clase"
                                            >
                                                <MenuItem value={"Pendiente"}>Pendiente</MenuItem>
                                                <MenuItem value={"Calificado"}>Calificado</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </GridItem>
                                </GridContainer>
                            </CardBody>
                        </Card>
                        <Card>
                            <CardHeader color="info" text>
                                <GridContainer>
                                    <GridItem xs={12} sm={12} md={6}>
                                        <h4 className="pull-left">Alumnos</h4>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={6}>
                                        <h4 className="pull-right" style={{ marginRight: "15px", marginTop: 0 }}>{this.state.ListaAlumnos.length} Alumno(s)</h4>
                                    </GridItem>
                                </GridContainer>
                            </CardHeader>
                            <CardBody>
                                <GridContainer>
                                    <GridItem xs={12} sm={12} md={12}>
                                        <div className="table-responsive-xl table-wrapper-scroll-y">
                                            <table className="table table-sm table-hover">
                                                <thead>
                                                    <th>Alumno</th>
                                                    <th>Estado</th>
                                                    <th></th>
                                                </thead>
                                                <tbody>
                                                    {this.state.cargandoAlumnos &&
                                                        <tr>
                                                            <td style={{ textAlign: "center", marginTop: "10px" }} colSpan={5}>Cargando...</td>
                                                        </tr>}
                                                    {alumnos}
                                                </tbody>
                                            </table>
                                        </div>
                                    </GridItem>
                                </GridContainer>
                            </CardBody>
                        </Card>
                    </GridItem>
                </GridContainer>
                <div id="">
                    <ModalPregunta
                        Titulo={"TOEFL"}
                        Cuerpo={`¿Estas seguro de empezar proceso de TOEFL para el elumno: ${this.state.NombreAlumno || ""}?`}
                        show={this.state.show}
                        headerColor="info"
                        eventClick={this.eventoModalPregunta}
                    />
                    {agregar}
                </div>
                <div id="">
                    <Snackbar
                        place="tr"
                        color={this.state.colorNotificacion}
                        message={this.state.mensaje}
                        open={this.state.br}
                        closeNotification={() => this.setState({ br: false })}
                        close
                    />
                </div>

            </div>
        )
    }
}

export default withStyles(headerLinksStyle)(BuscarExpedientes);